import React from 'react'

const Overlay = (props) => {
  return <div className="overlay"></div>
}

export default Overlay